import React from "react";
import T from "prop-types";
import HoverFlag from "MODULES/parts/components/HoverFlag";

export function AsIsFlag({ className, lineItem }) {
  if (!lineItem.as_is) return null;

  return <HoverFlag className={className} text="As-is" abbr="AI" inline />;
}

AsIsFlag.propTypes = {
  className: T.string,
  lineItem: T.shape({
    as_is: T.bool
  })
};



// WEBPACK FOOTER //
// ./app/modules/IncomingQuotes/shared/AsIsFlag.jsx